import moment from 'moment';

const serverFormat = 'MM/DD/YYYY hh:mm a';
const frontFormat = 'YYYY-MM-DDTHH:mm';

const now = () => {
  return moment().format(frontFormat);
};
const nowDate = () => {
  return moment().toDate();
};
const isPast = (date: string) => {
  return moment(date).diff(moment()) < 0;
};
const addMinutes = (date: Date, minutes: number) => {
  return moment(date).add(minutes, 'minutes').format(frontFormat);
};
const addDays = (date: Date, days: number) => {
  return moment(date).add(days, 'days').format(frontFormat);
};
const convertToServerFormatFromString = (date: string) => {
  return moment(date).format(serverFormat);
};
const convertToServerFormat = (date: Date) => {
  return moment(date).format(serverFormat);
};

const convertToFrontFormat = (date: Date) => {};

const formatDate = (dateString: string) => {
  try {
    // Remove timezone before parsing
    const parts = dateString.split(' ');
    const dateTime = parts.slice(0, -1).join(' ');

    // Parse the date
    const [datePart, timePart] = dateTime.split(' ');
    const [month, day, year] = datePart.split('/');
    const [time, period] = timePart.split(' ');
    const [hours, minutes] = time.split(':');

    const date = new Date(
      parseInt(year),
      parseInt(month) - 1,
      parseInt(day),
      period === 'PM' ? parseInt(hours) + 12 : parseInt(hours),
      parseInt(minutes),
    );

    // Format the date
    const formatter = new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    return formatter.format(date).replace(',', '').replace(',', ' at');
  } catch (error) {
    return dateString;
  }
};

export const dateHelper = {
  now,
  nowDate,
  isPast,
  addMinutes,
  addDays,
  convertToServerFormatFromString,
  convertToServerFormat,
  convertToFrontFormat,
  formatDate,
};
